import create from "zustand";
import { Vector3 } from "three";

export const useStore = create((set, get) => {
    return {
        appInitialized: false, // APP/SHADE COMPLETE => (ready to view) // Curtain Raised,
        model_loaded: false, // asset in scene (pre curtain)
        appStatus: "SHADE_START", // PRE APP Loading Stages
        hrx: {},
        modalView: { display: "", status: false }, // Which Modal to show
        variants_payload: {}, // Payload - (Response API)
        variant_id: "", // MAIN Variant ID,
        // dynamic_text_settings: null,
        poiPulse: 1, //new
        poiPulseUp: true, //new
        settings: {
            product_session_id: "",
            variant_session_id: "",
            viewer_session_id: "",
            levar_session_token: "",
            origin: "",
            home_url: "",
            viewer_type: "",
            store_id: "",
            variant_type: "",
            cLogo: "",
            addToCartBtn: ""
        }, // All Basic INFO
        deltas: [], //new
        fps: 60, //new 
        clockCount: 0, //new
        billboard_settings: {
            lattice_graph: [], // new
            clipAnchors: [], // new
            lattice: [], // new
            orbit_controls_target: new Vector3(0, 0, 0), // new
            current_camera_keyframe: 0, // new
            camera_move_positions: [], // new
            target_positions: [], // new
            is_camera_keyframe: false, // new // is camera moving
            camera_density: 120, // new // could change to variable (in)
            billboard_listener_click: false,
        },
        model: {
            size: { x: 0, y: 0, z: 0 }, // used for shadows
            lengthSum: {},
            bounds: []
            // bounds3D: {},
        },
        model_options: {
            status: false,
        },
        screen: {
            // center: {},
            // margins: [],
            // space: {},
            // aspect: 0,
            aspectNormalized: 0,
            // width: 0, 
            // height: 0
        },
        scene_controls: {
            orbit_controls_enabled: true,
            billboards_enabled: null,
            variant_switch_enabled: null,
            billboard_variant_switch_enabled: null,
            active_board: null,
            active_tab: 0,
        },
        // active_animations: false, // OLD
        model_animations: {
            model_animation_status: false,
            bones_default: false,
        },
        clipless_animations: {
            turn: 0,
            hover: 0
        },
        twoD_settings: {
            full_screen_loading: false
        },
        store_settings: {},
        actions: {
            setAppInitialize(status) {
                set(state => ({ appInitialized: status }))
            },
            // fetch: async (type) => {
            //     const response = await fetch(pond)
            //     const data = await response.json();
            // },
            setModel({ size, aspectNormalized, bounds, model_loaded, appInitialized }) {
                // console.log('HERE',
                //     size, aspectNormalized, bounds, model_loaded, appInitialized
                // )
                // size: size, aspectNormalized: aspectNormalized, bounds, model_loaded: true, appInitialized: true
                set(state => ({
                    model_loaded: model_loaded,
                    appInitialized: appInitialized,
                    model: {
                        // bounds3D: bounds3D,
                        bounds: bounds,
                        size: size,
                        lengthSum: size.x + size.y + size.z
                    },
                    screen: {
                        //             center: center,
                        //             margins: margins,
                        //             space: space, 
                        //             aspect: aspect,
                        aspectNormalized: aspectNormalized
                    }
                }))
            },
            setVariant(variant_id) {
                set(state => ({ variant_id }))
            },
            pulsePoi() {
                if (get().poiPulseUp) {
                    if (get().poiPulse < 1.3) {
                        set(state => ({ poiPulse: state.poiPulse + 0.0025 }))
                    } else {
                        set({ poiPulseUp: false })
                    }
                } else {
                    if (get().poiPulse > 1) {
                        set(state => ({ poiPulse: state.poiPulse - 0.0025 }))
                    } else {
                        set({ poiPulseUp: true })
                    }
                }
            },
            handleModalDisplay(info) {
                set(state => ({
                    modalView: { ...info }
                }))
            },
            setCloseBoard() {
                set(state => ({
                    scene_controls: { ...state.scene_controls, active_board: null }
                }))
            },
            setScreen(width, height) {
                set(state => ({
                    screen: { ...state.screen, width: width, height: height }
                }))
            },
            setModelAnimation(status) {
                set(state => ({
                    model_animations: { ...state.model_animations, model_animation_status: status }
                }))
            },
            setBonesAnimation(status) {
                set(state => ({
                    model_animations: { ...state.model_animations, bones_default: status }
                }))
            },
            setCliplessAnimation(type, status) {
                if (type === 'turn') {
                    set(state => ({
                        clipless_animations: { ...state.clipless_animations, turn: status }
                    }));
                }
                if (type === 'hover') {
                    set(state => ({
                        clipless_animations: { ...state.clipless_animations, hover: status }
                    }));
                }
            },
            startCameraMovePOI(points, targetPositions, point_index) {
                set(state => ({
                    billboard_settings: {
                        ...state.billboard_settings,
                        current_camera_keyframe: 0,
                        camera_move_positions: points,
                        target_positions: targetPositions,
                        is_camera_keyframe: true,
                        billboard_listener_click: false,
                    },
                    scene_controls: {
                        ...state.scene_controls,
                        active_board: point_index
                    }
                }));
            },
            setCurrentCameraPositionPOI(lookPosition) {
                set(state => ({
                    billboard_settings: {
                        ...state.billboard_settings,
                        orbit_controls_target: lookPosition,
                        current_camera_keyframe: state.billboard_settings.current_camera_keyframe + 1,
                    }
                }));
            },
            stopCameraMovePOI(orbitControlsTarget) {
                set(state => ({
                    billboard_settings: {
                        ...state.billboard_settings,
                        current_locator_target: orbitControlsTarget,
                        current_camera_keyframe: 0,
                        is_camera_keyframe: false,
                    }
                }));
            },
            countClock(delta) { //new
                if (get().clockCount < 3) {
                    const deltas = get().deltas;

                    if (deltas.length === 120) {
                        set({
                            fps: 1 / (deltas.reduce((a, b) => a + b, 0) / deltas.length),
                            deltas: [delta],
                            clockCount: get().clockCount + 1
                        })
                    } else {
                        deltas.push(delta)
                        set({ deltas: deltas })
                    }
                }
            },
            changePOI(selected_poi_index) {
                set(state => ({
                    scene_controls: {
                        ...state.scene_controls,
                        active_board: selected_poi_index,
                    },
                    billboard_settings: {
                        ...state.billboard_settings,
                        billboard_listener_click: true
                    }
                }));
            },
            setFullScreenLoading(status) {
                set(state => ({
                    twoD_settings: {
                        full_screen_loading: status
                    },
                }));
            }
        }
    }
});

// setChangeVariant: async variant_id => {
    // set(state => ({ variant_id }))
    // await sendAnalyticsData({ event_type: 'viewer_page_load' });
// },    